import { render, staticRenderFns } from "./RegionDetails.vue?vue&type=template&id=044c17e4"
import script from "./RegionDetails.vue?vue&type=script&lang=js"
export * from "./RegionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('044c17e4')) {
      api.createRecord('044c17e4', component.options)
    } else {
      api.reload('044c17e4', component.options)
    }
    module.hot.accept("./RegionDetails.vue?vue&type=template&id=044c17e4", function () {
      api.rerender('044c17e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/RegionDetails.vue"
export default component.exports